export const SELECT_ORDERING_SYSTEM = 'SELECT_ORDERING_SYSTEM';
export const SELECT_SHOP_AND_CONFIG = 'SELECT_SHOP_AND_CONFIG';
export const SELECT_SEARCH_ORDER_SHOPS = 'SELECT_SEARCH_ORDER_SHOPS';
export const SET_SEARCH_ORDERS_ACTION = 'SET_SEARCH_ORDERS_ACTION';
export const SET_SEARCH_ORDERS_QUERY = 'SET_SEARCH_ORDERS_QUERY';
export const SET_ORDERS = 'SET_ORDERS';
export const CLEAR_ORDERS = 'CLEAR_ORDERS';
export const SELECT_ORDER = 'SELECT_ORDER';
export const SELECT_ORDER_TASK = 'SELECT_ORDER_TASK';
export const SHOW_ORDERS_SEARCH_ERROR = 'SHOW_ORDERS_SEARCH_ERROR';
export const CLEAR_ORDER_SEARCH_STATE = 'CLEAR_ORDER_SEARCH_STATE';
export const SET_SELECTED_ITEM = 'SET_SELECTED_ITEM';
export const SET_SELECTED_ALL_ITEMS = 'SET_SELECTED_ALL_ITEMS';
export const SET_SELECTED_ITEMS_QUANTITY = 'SET_SELECTED_ITEMS_QUANTITY';
export const SET_SELECTED_NESTED_SUBITEMS = 'SET_SELECTED_NESTED_SUBITEMS';
export const CLEAR_SELECTED_NESTED_SUBITEMS = 'CLEAR_SELECTED_NESTED_SUBITEMS';
export const SET_REFUNDS_COUNT = 'SET_REFUNDS_COUNT';
export const SET_RUTR_EVENTS = 'SET_RUTR_EVENTS';
export const SET_RBI_CUSTOMER_ID = 'SET_RBI_CUSTOMER_ID';
export const SET_RBI_CUSTOMER_BIRTHDAY = 'SET_RBI_CUSTOMER_BIRTHDAY';
export const SET_RBI_LOYALTY_ID = 'SET_RBI_LOYALTY_ID';
export const SET_RBI_COUPONS_INFO = 'SET_RBI_COUPONS_INFO';
export const SET_RBI_ASSIGNED_OFFERS = 'SET_RBI_ASSIGNED_OFFERS';
export const SET_SELECTED_RBI_ITEMS_FOR_REFUND = 'SET_SELECTED_RBI_ITEMS_FOR_REFUND';
export const SET_SELECTED_RBI_ITEMS_FOR_COUPON = 'SET_SELECTED_RBI_ITEMS_FOR_COUPON';
export const SET_SELECTED_RBI_ITEMS_FOR_LOYALTY_POINTS = 'SET_SELECTED_RBI_ITEMS_FOR_LOYALTY_POINTS';
export const SET_RBI_APPROVED_REFUND_AMOUNT = 'SET_RBI_APPROVED_REFUND_AMOUNT';
export const SET_SELECTED_CHEGG_BOOK_ISSUES_ORDER = 'SET_SELECTED_CHEGG_BOOK_ISSUES_ORDER';
export const SET_REFUND_AMOUNT_DETAILS = 'SET_REFUND_AMOUNT_DETAILS';
export const CLEAR_SELECTED_ITEMS = 'CLEAR_SELECTED_ITEMS';
export const SET_LOADING_ORDER_ID = 'SET_LOADING_ORDER_ID';
export const SET_SHIPPO_TRACKING_INFO = 'SET_SHIPPO_TRACKING_INFO';
export const CLEAR_SNIPPET_TEXT = 'CLEAR_SNIPPET_TEXT';
export const CLEAR_INVALID_SNIPPET_DATA = 'CLEAR_INVALID_SNIPPET_DATA';
export const SET_SEARCH_TYPE = 'SET_SEARCH_TYPE';
export const SET_SUBSCRIPTION_FREQUENCY = 'SET_SUBSCRIPTION_FREQUENCY';
export const SET_RETURN_LABEL_LINK = 'SET_RETURN_LABEL_LINK';
export const SET_RETURN_SHIPMENT_TRACKING_NUMBER = 'SET_RETURN_SHIPMENT_TRACKING_NUMBER';
export const SET_RETURN_SHIPMENT_CARRIER = 'SET_RETURN_SHIPMENT_CARRIER';
export const SET_RETURN_ITEMS = 'SET_RETURN_ITEMS';
export const SET_REFUND_AMOUNT = 'SET_REFUND_AMOUNT';
export const SET_REFUND_AMOUNT_FORMATTED = 'SET_REFUND_AMOUNT_FORMATTED';
export const SET_REFUND_SHIPPING_AMOUNT = 'SET_REFUND_SHIPPING_AMOUNT';
export const SET_STORE_CREDIT_AMOUNT = 'SET_STORE_CREDIT_AMOUNT';
export const SET_CANCELED_ITEMS = 'SET_CANCELED_ITEMS';
export const SET_SHOW_CONFIRMATION_PAGE = 'SET_SHOW_CONFIRMATION_PAGE';
export const RESET_SHOW_CONFIRMATION_PAGE = 'RESET_SHOW_CONFIRMATION_PAGE';
export const SET_DISCOUNT_PERIODS = 'SET_DISCOUNT_PERIODS';
export const SET_ITEM_AND_DISCOUNT_PERIOD_MATCHES = 'SET_ITEM_AND_DISCOUNT_PERIOD_MATCHES';
export const SET_SELECTED_DISCOUNT_PERIOD = 'SET_SELECTED_DISCOUNT_PERIOD';
export const SET_SELECTED_COUPON_CODE_TYPE = 'SET_SELECTED_COUPON_CODE_TYPE';
export const SET_REFUNDS_ON_SHOPIFY_ORDER = 'SET_REFUNDS_ON_SHOPIFY_ORDER';
export const SELECT_SHOP_NAME = 'SELECT_SHOP_NAME';
export const SET_RETURN_NOTE = 'SET_RETURN_NOTE';
export const SET_RETURN_ORDER_ITEMS = 'SET_RETURN_ORDER_ITEMS';
export const SET_RETURN_REASON = 'SET_RETURN_REASON';
export const SET_LAST_ORDER_IN_SELECTED_SUBBSCRIPTION = 'SET_LAST_ORDER_IN_SELECTED_SUBBSCRIPTION';
export const SET_AMAZON_ORDER_WARRANTY_TOTAL_YEARS = 'SET_AMAZON_ORDER_WARRANTY_TOTAL_YEARS';
export const SET_CURRENCY_CODE = 'SET_CURRENCY_CODE';
export const SET_ORDER_TOTAL = 'SET_ORDER_TOTAL';
export const UPDATE_SELECTED_ORDER = 'UPDATE_SELECTED_ORDER';
export const ADD_CANCEL_AND_REFUND_ITEM = 'ADD_CANCEL_AND_REFUND_ITEM';
export const ADD_REFUND_ONLY_ITEM = 'ADD_REFUND_ONLY_ITEM';
export const ADD_CANCEL_ONLY_ITEM = 'ADD_CANCEL_ONLY_ITEM';
export const ADD_DISCOUNT_ONLY_ITEM = 'ADD_DISCOUNT_ONLY_ITEM';
export const CLEAR_CANCEL_REFUND_DISCOUNT_TREE_ITEMS = 'CLEAR_CANCEL_REFUND_DISCOUNT_TREE_ITEMS';
export const SET_ACTION_REASONS = 'SET_ACTION_REASONS';
export const SELECT_MULTI_DOMAIN = 'SELECT_MULTI_DOMAIN';
export const SELECT_SIMPLR_ORDER_MULTI_DOMAIN = 'SELECT_SIMPLR_ORDER_MULTI_DOMAIN';
export const SET_CUSTOMER_GROUPS = 'SET_CUSTOMER_GROUPS';
export const SET_SELECTED_CUSTOMER_GROUP_ID = 'SET_SELECTED_CUSTOMER_GROUP_ID';
export const SET_SNIPPET_TEXT = 'SET_SNIPPET_TEXT';
export const ADD_SNIPPET_TEXT = 'ADD_SNIPPET_TEXT';
export const SET_INVALID_SNIPPET_DATA = 'SET_INVALID_SNIPPET_DATA';
export const SET_ORDER_SEARCH = 'SET_ORDER_SEARCH';
export const ADD_EXTRA_LASTMILE_INFO = 'ADD_EXTRA_LASTMILE_INFO';
export const CLEAR_EXTRA_LASTMILE_INFO = 'CLEAR_EXTRA_LASTMILE_INFO';
export const SET_ORDER_SHIPPING_ADDRESS = 'SET_ORDER_SHIPPING_ADDRESS';
export const SET_SHOPIFY_ORDER_SHIPPING_ADDRESS = 'SET_SHOPIFY_ORDER_SHIPPING_ADDRESS';
export const SET_NUMBER_SUPPORT_TRANSACTIONS = 'SET_NUMBER_SUPPORT_TRANSACTIONS';
export const SET_ADDITIONAL_ORDER_DETAILS = 'SET_ADDITIONAL_ORDER_DETAILS';
export const SET_SELECTED_PRODUCT = 'SET_SELECTED_PRODUCT';
export const SET_PRODUCTS_LIST = 'SET_PRODUCTS_LIST';
export const SET_PRODUCT_SEARCH_QUERY = 'SET_PRODUCT_SEARCH_QUERY';
export const RBI_SET_STORES = 'RBI_SET_STORES';
export const SET_ORDER_TAGS = 'SET_ORDER_TAGS';
export const SET_DYNAMIC_ORDER_SEARCH_VALUE = 'SET_DYNAMIC_ORDER_SEARCH_VALUE';
